export default function NotFound() {
  return (
    <div className="h-full flex items-center justify-center bg-background-main" style={{ padding: 48 }}>
      <div style={{ maxWidth: 460 }}>
        <h1 className="font-jakarta font-bold text-white" style={{ fontSize: 20, lineHeight: '24px', marginBottom: 12 }}>
          That page could not be found
        </h1>
        <p className="font-mulish text-text-support" style={{ fontSize: 12, lineHeight: '22px' }}>
          Check the link you were sent, or contact the Stears data team and we will send you a new one.
        </p>
      </div>
    </div>
  )
}
